import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import faSend from '@fortawesome/fontawesome-free-solid/faPaperPlane';

const EmailSignup = ({ action, label, next = '/' }) => {

  return (
    <form className="e84-email-signup"
      name="mc-embedded-subscribe-form"
      action={ action }
      method="post"
    >
      { !!label && <label htmlFor="mce-EMAIL">{ label }</label> }

      <div className="input-group">
        <input type="email"
          name="EMAIL"
          id="mce-EMAIL"
          className="input-group-text"
          placeholder="Enter E-Mail Address"
        />

        <button type="submit"
          name="submit"
          id="mc-embedded-subscribe"
          className="button"
          title="Submit Button"
        >
          <FontAwesomeIcon icon={ faSend } />
        </button>
      </div>

      <input type="hidden" name="_next" value={ next } />
    </form>
  );

};

EmailSignup.propTypes = {
  action: PropTypes.string,
  label: PropTypes.string,
  next: PropTypes.string,
};

export default EmailSignup;
